(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@fyne/ui", [], factory);
	else if(typeof exports === 'object')
		exports["@fyne/ui"] = factory();
	else
		root["@fyne/ui"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "RUS4");
/******/ })
/************************************************************************/
/******/ ({

/***/ "BhS4":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("cDf5");

// https://github.com/JamesMGreene/document.currentScript

/*!
 * document.currentScript
 * Polyfill for `document.currentScript`.
 * Copyright (c) 2016 James M. Greene
 * Licensed MIT
 * https://github.com/JamesMGreene/document.currentScript
 * v1.1.0
 */
(function () {
  // Live NodeList collection
  var scripts = document.getElementsByTagName("script"); // Check if the browser supports the `readyState` property on `script` elements

  var supportsScriptReadyState = ("readyState" in (scripts[0] || document.createElement("script"))); // Lousy browser detection for [not] Opera

  var isNotOpera = !window.opera || window.opera.toString() !== "[object Opera]"; // Guaranteed accurate in IE 6-10.
  // Not supported in any other browsers. =(

  var canPolyfill = supportsScriptReadyState && isNotOpera; // Attempt to retrieve the native `document.currentScript` accessor method

  var nativeCurrentScriptFn = function (doc) {
    /*jshint proto:true */
    var hasNativeMethod = ("currentScript" in doc);
    var canGetDescriptor = typeof Object.getOwnPropertyDescriptor === "function";
    var canGetPrototype = typeof Object.getPrototypeOf === "function";
    var canUseDunderProto = _typeof("test".__proto__) === "object";

    function _invokeNativeCurrentScriptMethod() {
      var des,
          csFnIsNotOurs = true;

      if (canGetDescriptor) {
        des = Object.getOwnPropertyDescriptor(doc, "currentScript") || undefined;

        if (des && typeof des.get === "function" && des.get === _currentEvaluatingScript) {
          csFnIsNotOurs = false;
        }
      } // Potentially dangerous hack...


      return csFnIsNotOurs ? doc.currentScript : null;
    }

    function _getProto(obj) {
      var proto;

      if (obj != null) {
        proto = canGetPrototype ? Object.getPrototypeOf(obj) : canUseDunderProto ? obj.__proto__ : obj.constructor != null ? obj.constructor.prototype : undefined;
      }

      return proto;
    }

    var nativeFn = function _getCurrentScriptDef(docSelfOrAncestor, doc) {
      var des, cs;

      if (hasNativeMethod && canGetDescriptor && docSelfOrAncestor && docSelfOrAncestor !== Object.prototype && doc && doc !== Object.prototype) {
        if (canGetDescriptor) {
          des = Object.getOwnPropertyDescriptor(docSelfOrAncestor, "currentScript") || undefined;

          if (des && typeof des.get === "function") {
            cs = des.get;
          }
        }

        if (!cs) {
          cs = _getCurrentScriptDef(_getProto(docSelfOrAncestor), doc);
        }
      }

      if (!cs) {
        cs = _invokeNativeCurrentScriptMethod;
      } else if (cs === _currentEvaluatingScript) {
        cs = undefined;
      }

      return cs;
    }(doc, doc);

    return nativeFn;
  }(document); // Top-level API (compliant with `document.currentScript` specifications)
  //
  // Get the currently "executing" (i.e. EVALUATING) `script` DOM
  // element, per the spec requirements for `document.currentScript`.
  //
  // IMPORTANT: This polyfill CANNOT achieve 100% accurate results
  //            cross-browser. ;_;


  function _currentEvaluatingScript() {
    // Yes, this IS possible, i.e. if a script removes other scripts (or itself)
    if (scripts.length === 0) {
      return null;
    } // Guaranteed accurate in IE 6-10.
    // Not supported in any other browsers. =(


    if (canPolyfill) {
      for (var i = scripts.length; i--;) {
        if (scripts[i] && scripts[i].readyState === "interactive") {
          return scripts[i];
        }
      }
    } // If the native method exists, defer to that as a last-ditch effort


    if (typeof nativeCurrentScriptFn === "function" && _currentEvaluatingScript.doNotDeferToNativeMethod !== true) {
      return nativeCurrentScriptFn.call(document) || null;
    } // Any other attempts cannot be guaranteed and, as such, should be left out
    // from this "Strict Mode" behavior.
    // Alas, returning `null` here is not necessarily accurate either.
    // We could return `undefined` instead but that would not comply with the spec
    // in cases where it should correctly be returning `null`.


    return null;
  } // Allow a last-ditch effort to use the native `document.currentScript` accessor
  // method (if it exists and can be retrieved)?


  _currentEvaluatingScript.doNotDeferToNativeMethod = false; // Inspect the polyfill-ability of this browser

  var needsPolyfill = !("currentScript" in document);

  var canDefineProp = typeof Object.defineProperty === "function" && function () {
    var result;

    try {
      Object.defineProperty(document, "_xyz", {
        get: function get() {
          return "blah";
        },
        configurable: true
      });
      result = document._xyz === "blah";
      delete document._xyz;
    } catch (e) {
      result = false;
    }

    return result;
  }(); // Add the "private" property for testing, even if the real property can be polyfilled


  document._currentScript = _currentEvaluatingScript; // Polyfill it!

  if (needsPolyfill && canDefineProp && typeof canPolyfill !== "undefined" && canPolyfill) {
    Object.defineProperty(document, "currentScript", {
      get: _currentEvaluatingScript
    });
  }
})();

/***/ }),

/***/ "LpkI":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller
// https://github.com/amiller-gh/currentScript-polyfill/blob/master/currentScript.js
// MIT license
(function (document) {
  var currentScript = 'currentScript'; // If browser needs currentScript polyfill, add get currentScript() to the document object

  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function get() {
        // IE 8-10 support script readyState
        // IE 11+ support stack trace
        try {
          throw new Error();
        } catch (err) {
          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i = 0,
              stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/ig.exec(err.stack),
              scriptLocation = stackDetails && stackDetails[1] || false,
              line = stackDetails && stackDetails[2] || false,
              currentLocation = document.location.href.replace(document.location.hash, ''),
              pageSource,
              inlineScriptSourceRegExp,
              inlineScriptSource,
              scripts = document.getElementsByTagName('script'); // Live NodeList collection

          if (scriptLocation === currentLocation) {
            pageSource = document.documentElement.outerHTML;
            inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
            inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
          }

          for (; i < scripts.length; i++) {
            // If ready state is interactive, return the script tag
            if (scripts[i].readyState === 'interactive') {
              return scripts[i];
            } // If src matches, return the script tag


            if (scripts[i].src === scriptLocation) {
              return scripts[i];
            } // If inline source matches, return the script tag


            if (scriptLocation === currentLocation && scripts[i].innerHTML && scripts[i].innerHTML.trim() === inlineScriptSource) {
              return scripts[i];
            }
          } // If no match, return null


          return null;
        }
      }
    });
  }
})(document);

/***/ }),

/***/ "RUS4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "EnvironmentConstants", function() { return /* binding */ EnvironmentConstants; });
__webpack_require__.d(__webpack_exports__, "environment", function() { return /* binding */ environment; });
__webpack_require__.d(__webpack_exports__, "constant", function() { return /* binding */ constant; });
__webpack_require__.d(__webpack_exports__, "setting", function() { return /* binding */ context_setting; });
__webpack_require__.d(__webpack_exports__, "scriptProp", function() { return /* binding */ context_scriptProp; });
__webpack_require__.d(__webpack_exports__, "ParseContext", function() { return /* binding */ ParseContext; });
__webpack_require__.d(__webpack_exports__, "context", function() { return /* binding */ context; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("cDf5");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : typeof_default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : typeof_default()(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __exportStar(m, exports) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}
;
function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) {
    throw e;
  }), verb("return"), i[Symbol.iterator] = function () {
    return this;
  }, i;

  function verb(n, f) {
    i[n] = o[n] ? function (v) {
      return (p = !p) ? {
        value: __await(o[n](v)),
        done: n === "return"
      } : f ? f(v) : v;
    } : f;
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}
;
function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
}
function __importDefault(mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
}
function __classPrivateFieldGet(receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  privateMap.set(receiver, value);
  return value;
}
// CONCATENATED MODULE: ./node_modules/lower-case/dist.es2015/index.js
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
var SUPPORTED_LOCALE = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      İ: "i",
      I: "\u0131",
      İ: "i"
    }
  },
  az: {
    regexp: /\u0130/g,
    map: {
      İ: "i",
      I: "\u0131",
      İ: "i"
    }
  },
  lt: {
    regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
    map: {
      I: "i\u0307",
      J: "j\u0307",
      Į: "\u012F\u0307",
      Ì: "i\u0307\u0300",
      Í: "i\u0307\u0301",
      Ĩ: "i\u0307\u0303"
    }
  }
};
/**
 * Localized lower case.
 */

function localeLowerCase(str, locale) {
  var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
  if (lang) return lowerCase(str.replace(lang.regexp, function (m) {
    return lang.map[m];
  }));
  return lowerCase(str);
}
/**
 * Lower case as a function.
 */

function lowerCase(str) {
  return str.toLowerCase();
}
// CONCATENATED MODULE: ./node_modules/no-case/dist.es2015/index.js
 // Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").

var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g]; // Remove all non-word characters.

var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */

function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.splitRegexp,
      splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a,
      _b = options.stripRegexp,
      stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b,
      _c = options.transform,
      transform = _c === void 0 ? lowerCase : _c,
      _d = options.delimiter,
      delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length; // Trim the delimiter from around the output string.

  while (result.charAt(start) === "\0") {
    start++;
  }

  while (result.charAt(end - 1) === "\0") {
    end--;
  } // Transform each token independently.


  return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */

function replace(input, re, value) {
  if (re instanceof RegExp) return input.replace(re, value);
  return re.reduce(function (input, re) {
    return input.replace(re, value);
  }, input);
}
// CONCATENATED MODULE: ./node_modules/pascal-case/dist.es2015/index.js


function pascalCaseTransform(input, index) {
  var firstChar = input.charAt(0);
  var lowerChars = input.substr(1).toLowerCase();

  if (index > 0 && firstChar >= "0" && firstChar <= "9") {
    return "_" + firstChar + lowerChars;
  }

  return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCaseTransformMerge(input) {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function pascalCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return noCase(input, _assign({
    delimiter: "",
    transform: pascalCaseTransform
  }, options));
}
// CONCATENATED MODULE: ./node_modules/camel-case/dist.es2015/index.js


function camelCaseTransform(input, index) {
  if (index === 0) return input.toLowerCase();
  return pascalCaseTransform(input, index);
}
function camelCaseTransformMerge(input, index) {
  if (index === 0) return input.toLowerCase();
  return pascalCaseTransformMerge(input);
}
function camelCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return pascalCase(input, _assign({
    transform: camelCaseTransform
  }, options));
}
// CONCATENATED MODULE: ./node_modules/dot-case/dist.es2015/index.js


function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return noCase(input, _assign({
    delimiter: "."
  }, options));
}
// CONCATENATED MODULE: ./node_modules/param-case/dist.es2015/index.js


function paramCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return dotCase(input, _assign({
    delimiter: "-"
  }, options));
}
// EXTERNAL MODULE: ./src/helpers/currentScript-IE9-11.js
var currentScript_IE9_11 = __webpack_require__("LpkI");

// EXTERNAL MODULE: ./src/helpers/currentScript-IE6-10.js
var currentScript_IE6_10 = __webpack_require__("BhS4");

// CONCATENATED MODULE: ./src/helpers/currentScript.js
// first try to pollyfill for IE11
 // first try to pollyfill for IE8 or less

 // https://stackoverflow.com/questions/403967/how-may-i-reference-the-script-tag-that-loaded-the-currently-executing-script

var script = function () {
  var cs = document.currentScript;

  if (!cs) {
    // find by pollyfill or dom query
    cs = !cs && document._currentScript && document._currentScript(); // don't do this, would break if these props change
    //cs = !cs && document.getElementById('fwxfrm-script');
    //cs = !cs && document.querySelector('script[data-name="fwxfrm"]');
  }

  if (!cs) {
    // assume last script
    var scripts = document.getElementsByTagName("script");
    cs = scripts[scripts.length - 1];
  }

  var _cs = cs,
      baseURI = _cs.baseURI,
      src = _cs.src;
  var cur_path = baseURI;
  var src_path = src && src.match(/^(https?\:\/\/[^\/]+\/)/gi)[0]; //console.log('current script:', {cs,baseURI,src,cur_path,src_path});

  return {
    src_path: src_path,
    cur_path: cur_path,
    src: src,
    tag: cs
  };
}();
// CONCATENATED MODULE: ./src/context.js
//import React from 'react';

 //console.log('FYNEWORKS CONTEXT', {a:process.env.PATH,b:script.src_path,s:script,env:process.env})
//console.log('FYNEWORKS CONTEXT process.env.PATH', process.env.PATH)
//console.log('FYNEWORKS CONTEXT script.src_path', script.src_path)
//console.log('FYNEWORKS CONTEXT process.env', process.env)

var APP_BASE = script.src_path || {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}.PATH || './';
var EnvironmentConstants = function EnvironmentConstants() {
  var x = /^(REACT_APP_)?(FWX_)/gi;
  var o = {
    APP_BASE: APP_BASE
  };
  var i = Object.assign({}, {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"});
  var k = Object.keys(i).filter(function (n) {
    return n.match(x);
  });
  k.forEach(function (n) {
    o[n.replace(x, 'FWX_').toUpperCase()] = i[n];
  });
  return o;
};
var environment = function environment(n) {
  var u = n.replace(/\s+/gi, '_').toUpperCase(); //const l = n.replace(/\s+/gi,'_').toLowerCase();
  ////console.log('Fyneworks config constant', u, l);

  return {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['REACT_APP_FWX_' + u] || {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['FWX_' + u]; // see https://create-react-app.dev/docs/adding-custom-environment-variables/
};
var constant = function constant(n) {
  var dataset = function dataset() {
    return Object.assign({}, document.body.dataset);
  };

  var u = n.replace(/\s+/gi, '_').toUpperCase();
  var l = n.replace(/\s+/gi, '_').toLowerCase(); ////console.log('Fyneworks config constant', u, l);

  return {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['REACT_APP_FWX_' + u] || {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['FWX_' + u] || window['FWX_' + u] || dataset[l]; // see https://create-react-app.dev/docs/adding-custom-environment-variables/
};
var context_setting = function setting(n) {
  var fwx = Object.assign({}, window.fwx || {}, window.FWX || {});
  var u = n.replace(/\s+/gi, '_').toUpperCase();
  var l = n.replace(/\s+/gi, '_').toLowerCase();
  var c = camelCase(n.replace(/_+/gi, ' ')); ////console.log('Fyneworks config setting', u, l, c);

  return fwx[u] || fwx[c] || fwx[l];
};
var context_scriptProp = function scriptProp(n) {
  var dataset = function dataset() {
    return Object.assign({}, document.body.dataset);
  };

  var c = camelCase(n.replace(/[-\s+]/gi, '_'));
  var p = paramCase(n.replace(/[-\s+]/gi, '_')); ////console.log('Fyneworks config constant', u, l, d);

  return dataset && dataset[c] && dataset[p]; // see https://create-react-app.dev/docs/adding-custom-environment-variables/
}; ////console.log('Fyneworks config EnvironmentConstants()', EnvironmentConstants())

var ParseContext = function ParseContext(defaults, overrides) {
  //console.log('ParseContext invoked');
  var context = Object.assign({}, // inline defaults
  defaults || {}, // expose all environment vars if needed
  EnvironmentConstants(), //{ env:Environment() },
  // run-time defaults
  {
    edition: context_scriptProp('edition') || constant('edition') || context_setting('edition') || window['EDITION'],
    timezone: context_scriptProp('timezone') || constant('timezone') || context_setting('timezone'),
    //  window['FWX_TIMEZONE'] || dataset.timezone,
    license: context_scriptProp('license') || constant('license') || context_setting('license'),
    domain: context_scriptProp('domain') || constant('domain') || context_setting('domain'),
    //  window['FWX_DOMAIN'] || dataset.domain,
    base: context_scriptProp('base') || constant('base') || context_setting('base'),
    path: context_scriptProp('API_PATH') || constant('API_PATH') || context_setting('API_PATH') || '/api',
    cur: context_scriptProp('cur') || constant('cur') || context_setting('cur'),
    //  window['FWX_CUR'] || dataset.cur,
    cursym: context_scriptProp('cursym') || constant('cursym') || context_setting('cursym'),
    //  window['FWX_CURSYM'] || dataset.cursym,
    curdec: context_scriptProp('curdec') || constant('curdec') || context_setting('curdec') //  window['FWX_CURDEC'] || dataset.curdec,

  }, // core config
  window.fwx && (window.fwx.config || {}), // site config
  window.FWX || {}, // accept runtime overrides
  overrides || {});

  if (!context.base) {
    if (context.domain) {
      context.base = 'https://' + context.domain;
    }
  }

  if (!context.base) {
    context.base = document.location.origin;
  }

  context.API_BASE = context.base + '' + context.path; // + '/';

  return context;
};
var context = ParseContext();
/* harmony default export */ var src_context = __webpack_exports__["default"] = (context); //console.log('FYNEWORKS CONTEXT RESULT (processed process.env and others)', context);
//export const FyneContext = React.createContext(context);

/***/ }),

/***/ "cDf5":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ })

/******/ });
});
//# sourceMappingURL=context.js.map